import * as React from 'react';
import styles from './tab-container.scss';
import { ToggleMode, ToggleOpen } from './toggle';
import { ViewMode } from 'app/area/case/types-store';

/**
 * TabContainer's DOM identifier, must be predefined due
 * to how portals work at time of coding
 */
export const TabContainerDomId = 'tabcontainer';

export interface TabContainerProps {
  label: string;
  visible: boolean;
  expandAll: boolean;
  activeSection: number | string;
  hasError?: boolean;
  translation: { [key: string]: string };
  changeViewMode?: (mode: ViewMode) => void;
  renderTabs: (onClick: (event: React.MouseEvent) => void) => React.ReactNode;
}
export interface TabContainerState {
  menuIsOpen: boolean;
  menuIsClosing: boolean;
}
export class TabContainer extends React.Component<TabContainerProps, TabContainerState> {
  public state: Readonly<TabContainerState> = {
    menuIsOpen: false,
    menuIsClosing: false
  };

  public componentDidUpdate(prevProps: TabContainerProps) {
    this.handleMobileTabSelect(prevProps);
  }

  private toggleMobileMenu = () => {
    if (this.state.menuIsOpen) {
      this.closeMobileMenu();
    } else {
      this.setState({
        menuIsOpen: true
      });
    }
  };

  private closeMobileMenu = () => {
    this.setState({ menuIsClosing: true });
    setTimeout(() => {
      this.setState({
        menuIsOpen: false,
        menuIsClosing: false
      });
    }, 300);
  };

  private handleMobileTabSelect(prevProps: TabContainerProps) {
    const { activeSection, expandAll } = this.props;
    const userDidSelect = activeSection && prevProps.activeSection !== activeSection
      || prevProps.expandAll !== expandAll;
    this.state.menuIsOpen && userDidSelect && this.setState({ menuIsOpen: false });
  }

  public render() {
    const {
      label,
      visible,
      expandAll,
      hasError,
      translation,
      changeViewMode,
      renderTabs: renderList
    } = this.props;
    const {
      menuIsClosing,
      menuIsOpen
    } = this.state;

    const menuStateStyles = menuIsOpen ? '' : styles.withClosedMenu;
    const closeAnimation = menuIsClosing ? styles.animateOut : '';
    const viewStyle = this.props.expandAll ? 'scroll-view' : 'tab-view';

    return (visible && <div className={`${styles.tabPanel} ${menuStateStyles} ${closeAnimation} ${viewStyle}`}>

      <div className={styles.tabSectionWrapper}>

        <ToggleOpen
          hasError={hasError}
          styles={styles}
          label={label}
          onClick={this.toggleMobileMenu}
        />

        <section className={styles.tabSection}>
          <h2>{label}</h2>
          {renderList(this.closeMobileMenu)}
          {!!changeViewMode && <div className={styles.switchViewButton}>
            <ToggleMode
              collapseText={translation.switch_to_tab}
              expandText={translation.switch_to_scroll}
              expandAll={expandAll}
              changeViewMode={changeViewMode}
            />
          </div>}
        </section>
      </div>

      {menuIsOpen && <div className={`${styles.mobileBackground} ${closeAnimation}`} tabIndex={0} onClick={this.closeMobileMenu} />}
    </div>);
  }
}
